import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import {
  excerpt,
  isLoggedIn,
  calculateTotalPrice,
} from "../../resources/helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Box, Typography } from "@mui/material";
import { removeFromCart } from "../../redux/features/cartSlice";

export default function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cart);
  const { products } = useSelector((state) => state.product);
  const { user } = useSelector((state) => state.auth);
  const [isUser, setIsUser] = useState(false);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    const flag = isLoggedIn();
    setIsUser(flag);
  }, [user]);

  const handleNavigation = () => {
    if (isUser) {
      navigate("/userdashboard");
    } else {
      navigate("/login");
    }
  };

  useEffect(() => {
    setFilteredProducts(products);
  }, [products]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSearch = () => {
    setSearchLoading(true);
    const filtered = products.filter((product) =>
      product.name.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredProducts(filtered);
    handleOpen();
    setSearchLoading(false);
  };

  const handleDetailsNavigation = (item) => {
    handleClose();
    navigate("/productDetails", { state: item });
  };

  const handleRemoveFromCart = (id) => {
    dispatch(removeFromCart(id));
  };

  return (
    <div>
      <header className="header-area header-style-1 header-style-5 header-height-2">
        <div className="mobile-promotion">
          <span>
            Grand opening, <strong>up to 15%</strong> off all items. Only
            <strong>3 days</strong> left
          </span>
        </div>
        <div className="header-middle header-middle-ptb-1 d-none d-lg-block">
          <div className="container">
            <div className="header-wrap">
              <div
                style={{
                  width: "10%",
                  height: "10%",
                }}
                className="logo"
              >
                <Link to="/">
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                    src="././././assets/imgs/theme/logo.png"
                    alt="logo"
                  />
                </Link>
              </div>

              {/* Search Bar  */}
              <div className="header-right">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                  className="search-style-2"
                >
                  <form
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      maxWidth: "650px",
                      border: "none",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Search for items..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      style={{
                        width: "100%",
                        padding: "20px 25px",
                        borderRadius: "25px 0 0 25px",
                        border: "2px solid #ddd",
                        fontSize: "16px",
                        transition: "all 0.3s ease",
                        background: "#fff",
                        boxShadow: "0 0 10px rgba(99, 4, 93, 0.2)",
                        outline: "none",
                      }}
                    />
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#63045D",
                        color: "#fff",
                        borderRadius: "0 25px 25px 0",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        transition: "background-color 0.3s ease",
                        outline: "none",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#52034C";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#63045D";
                      }}
                      onClick={handleSearch}
                      disabled={search?.length === 0}
                    >
                      <SearchIcon
                        style={{ fontSize: "24px", marginRight: "10px" }}
                      />
                      <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                        Search
                      </span>
                    </button>
                  </form>
                </div>

                <div className="header-action-right">
                  <div className="header-action-2">
                    <div className="header-action-icon-2">
                      <a className="mini-cart-icon">
                        <img
                          alt="MallSayLo"
                          src="././assets/imgs/theme/icons/icon-cart.svg"
                        />
                        {cart && cart?.length > 0 && (
                          <span className="pro-count blue">{cart?.length}</span>
                        )}
                      </a>
                      <div
                        className="cart-dropdown-wrap cart-dropdown-hm2"
                        style={{ maxHeight: 500, overflowY: "auto" }}
                      >
                        {cart && cart?.length > 0 ? (
                          cart?.map((item) => (
                            <ul key={item?._id}>
                              <li>
                                <div className="shopping-cart-img">
                                  <a>
                                    <img
                                      alt="MallSayLo"
                                      src={item?.featured_media}
                                    />
                                  </a>
                                </div>
                                <div className="shopping-cart-title">
                                  <h4>
                                    <a>{excerpt(item?.name, 10)}</a>
                                  </h4>
                                  <h4>
                                    <span>{item?.quantity} × </span>Rs.
                                    {item?.discount_price}
                                  </h4>
                                </div>
                                <div className="shopping-cart-delete">
                                  <a
                                    onClick={() =>
                                      handleRemoveFromCart(item?._id)
                                    }
                                  >
                                    <i className="fi-rs-cross-small" />
                                  </a>
                                </div>
                              </li>
                            </ul>
                          ))
                        ) : (
                          <p>Please Add products</p>
                        )}

                        <div className="shopping-cart-footer">
                          <div className="shopping-cart-total">
                            <h4>
                              Total <span>Rs.{calculateTotalPrice(cart)}</span>
                            </h4>
                          </div>
                          <div className="shopping-cart-button">
                            <Link to={"/cart"} className="outline">
                              View cart
                            </Link>
                            <Link to={"/checkout"}>Checkout</Link>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="header-action-icon-2">
                      <Button
                        sx={{
                          marginLeft: "6px",
                          backgroundColor: "#63045D",
                          "&:hover": {
                            backgroundColor: "#e6c577",
                          },
                        }}
                        variant="contained"
                        onClick={handleNavigation}
                      >
                        {isUser ? "Dashboard" : "Login"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-bottom header-bottom-bg-color sticky-bar">
          <div className="container">
            <div className="header-wrap header-space-between position-relative">
              <div className="logo logo-width-1 d-block d-lg-none">
                <a>
                  <img src="././assets/imgs/theme/logo.png" alt="logo" />
                </a>
              </div>
              <div className="header-nav d-none d-lg-flex">
                <div className="main-categori-wrap d-none d-lg-block"></div>
                <div className="main-menu main-menu-padding-1 main-menu-lh-2 d-none d-lg-block font-heading">
                  <nav>
                    <ul>
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/wishlist">Wishlist</Link>
                      </li>
                      <li>
                        <Link to="/About">About Us</Link>
                      </li>
                      <li>
                        <Link to="/Contact">Contact Us</Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="hotline d-none d-lg-flex">
                <img
                  src="././assets/imgs/theme/icons/icon-headphone-white.svg"
                  alt="hotline"
                />
                <p>
                  0300 - 920<span>24/7 Support Center</span>
                </p>
              </div>
              <div className="header-action-icon-2 d-block d-lg-none">
                <div className="burger-icon burger-icon-white">
                  <span className="burger-icon-top" />
                  <span className="burger-icon-mid" />
                  <span className="burger-icon-bottom" />
                </div>
              </div>
              <div className="header-action-right d-block d-lg-none">
                <div className="header-action-2">
                  <div className="header-action-icon-2">
                    <a>
                      <img
                        alt="MallSayLo"
                        src="././assets/imgs/theme/icons/icon-heart.svg"
                      />
                      <span className="pro-count white">4</span>
                    </a>
                  </div>
                  <div className="header-action-icon-2">
                    <a className="mini-cart-icon">
                      <img
                        alt="MallSayLo"
                        src="././assets/imgs/theme/icons/icon-cart.svg"
                      />
                      <span className="pro-count white">2</span>
                    </a>
                    <div className="cart-dropdown-wrap cart-dropdown-hm2">
                      <ul>
                        <li>
                          <div className="shopping-cart-img">
                            <a>
                              <img
                                alt="MallSayLo"
                                src="././assets/imgs/shop/thumbnail-3.jpg"
                              />
                            </a>
                          </div>
                          <div className="shopping-cart-title">
                            <h4>
                              <a>Black Leather Jacket</a>
                            </h4>
                            <h3>
                              <span>1 × </span>Rs.800.00
                            </h3>
                          </div>
                          <div className="shopping-cart-delete">
                            <a>
                              <i className="fi-rs-cross-small"></i>
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="shopping-cart-img">
                            <a>
                              <img
                                alt="MallSayLo"
                                src="././assets/imgs/shop/thumbnail-4.jpg"
                              />
                            </a>
                          </div>
                          <div className="shopping-cart-title">
                            <h4>
                              <a>Green Zipper Jacket</a>
                            </h4>
                            <h3>
                              <span>1 × </span>Rs.3500.00
                            </h3>
                          </div>
                          <div className="shopping-cart-delete">
                            <a>
                              <i className="fi-rs-cross-small"></i>
                            </a>
                          </div>
                        </li>
                      </ul>
                      <div className="shopping-cart-footer">
                        <div className="shopping-cart-total">
                          <h4>
                            Total:
                            <span>Rs.4300.00</span>
                          </h4>
                        </div>
                        <div className="shopping-cart-button">
                          <a className="btn btn-sm">View cart</a>
                          <a className="btn btn-sm btn-sum">Checkout</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Modal Component */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "700px",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 4,
            maxHeight: 500,
            overflowY: "auto",
          }}
        >
          <Typography variant="h4">Search Results</Typography>
          <Box mt={2}>
            {searchLoading ? (
              <p>Loading...</p>
            ) : filteredProducts && filteredProducts?.length > 0 ? (
              filteredProducts.map((item) => (
                <Box
                  key={item._id}
                  mb={2}
                  p={2}
                  sx={{ borderBottom: "1px solid #ddd" }}
                  onClick={() => handleDetailsNavigation(item)}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <Box sx={{ width: 60, height: 60 }}>
                      <img
                        src={item?.featured_media}
                        alt="featured Image"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: 12,
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                    <Box>
                      <Typography variant="h6">{item?.name}</Typography>
                      <Typography variant="body2">
                        {item?.discount_price}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <p> No Products found</p>
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
